import { IEnvironment } from 'config/env';

import devOps from './dev-ops';

// See dr-tf.ts; the same hosts move for the ops portal.
const environment: IEnvironment = {
  ...devOps,
  GQL_URL: 'https://api-dr.dev.ef.studio/gipfeli/',
  MEDIA_URL: 'https://teach-assets-dr.dev.ef.studio',
  TF_SVCGATEWAY_URL: 'https://api-dr.dev.ef.studio/teacher-first',
  CATALYST_PLAYER_URL: 'https://lesson-player-dr.dev.ef.studio/?product=gap-b2b',
  CONTENT_PREVIEW_URL: 'https://content-preview-dr.dev.ef.studio/',
  EVC_TUNNELS: {
    ...devOps.EVC_TUNNELS,
    US_NV: 'https://dev-dr.evc.ef.com',
  },
  DATADOG: devOps.DATADOG && {
    ...devOps.DATADOG,
    VIRTUAL_ENV: 'dr-dev',
  },
};

export default environment;
